import React, { useState, useEffect } from 'react';
import CourseCard from '../../components/Cours/CourseCard';
import coursesService from '../../services/coursesService';

const PopularCourses = () => {
  const [courses, setCourses] = useState([]);
  const [activeFilter, setActiveFilter] = useState({
    category: null,
    rating: null,
    difficulty: null
  });

  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(1);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    coursesService.getAllCourses()
      .then(data => {
        const list = Array.isArray(data) ? data : (data?.data ?? []);
        setCourses(list.slice(0, 8));
      })
      .catch(err => console.error('Erreur cours:', err));
  }, []);

  // Options pour les filtres
  const filterOptions = {
    category: ["Animation", "Design", "Illustration", "Lifestyle", "Business"],
    rating: ["Great", "Good", "Medium", "Low"],
    difficulty: ["Hard", "Medium", "Easy"]
  };

  // Détection de la taille d'écran
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      
      if (width < 480) {
        setSlidesPerView(1);
      } else if (width < 640) {
        setSlidesPerView(1.2);
      } else if (width < 768) {
        setSlidesPerView(1.5);
      } else {
        setSlidesPerView(4); // Pour les écrans larges, on utilise la grille normale
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleFilterClick = (filterType, value) => {
    setActiveFilter(prev => ({
      ...prev,
      [filterType]: prev[filterType] === value ? null : value
    }));
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === courses.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? courses.length - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-light-5">
      <div className="container mx-auto px-4">
        <div className="flex justify-center text-center mb-10">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-title font-bold text-dark-1 dark:text-white mb-4">
              Programme du Bootcamp
            </h2>
          </div>
        </div>

        {/* Filtres */}
        <div className="flex flex-wrap justify-center gap-4 mb-12 lg:mb-16">
          {/* Filtre Catégorie */}
          <div className="relative group">
            <button
              className="flex items-center justify-between text-button px-4 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-700 dark:text-gray-300 shadow-sm hover:shadow-md transition-shadow duration-300 min-w-[140px]"
              onClick={() => document.getElementById('category-dropdown').classList.toggle('hidden')}
            >
              <span>{activeFilter.category || "Category"}</span>
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div id="category-dropdown" className="hidden absolute z-10 mt-1 w-48 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg">
              {filterOptions.category.map((category, index) => (
                <button
                  key={index}
                  className={`block w-full text-left px-4 py-2 text-button ${activeFilter.category === category ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'}`}
                  onClick={() => handleFilterClick('category', category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Filtre Rating */}
          <div className="relative group">
            <button
              className="flex items-center text-button justify-between px-4 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-700 dark:text-gray-300 shadow-sm hover:shadow-md transition-shadow duration-300 min-w-[140px]"
              onClick={() => document.getElementById('rating-dropdown').classList.toggle('hidden')}
            >
              <span>{activeFilter.rating || "Rating"}</span>
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div id="rating-dropdown" className="hidden absolute z-10 mt-1 w-48 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg">
              {filterOptions.rating.map((rating, index) => (
                <button
                  key={index}
                  className={`block w-full text-left px-4 py-2 text-button ${activeFilter.rating === rating ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'}`}
                  onClick={() => handleFilterClick('rating', rating)}
                >
                  {rating}
                </button>
              ))}
            </div>
          </div>

          {/* Filtre Difficulté */}
          <div className="relative group">
            <button
              className="flex items-center justify-between text-button px-4 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-700 dark:text-gray-300 shadow-sm hover:shadow-md transition-shadow duration-300 min-w-[140px]"
              onClick={() => document.getElementById('difficulty-dropdown').classList.toggle('hidden')}
            >
              <span>{activeFilter.difficulty || "Difficulty"}</span>
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div id='difficulty-dropdown' className="hidden absolute z-10 mt-1 w-48 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg">
              {filterOptions.difficulty.map((difficulty, index) => (
                <button
                  key={index}
                  className={`block w-full text-left px-4 py-2 text-button ${activeFilter.difficulty === difficulty ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'}`}
                  onClick={() => handleFilterClick('difficulty', difficulty)}
                >
                  {difficulty}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Conteneur des cours - Carrousel sur mobile, grille sur desktop */}
        {isMobile ? (
          <div className="relative overflow-hidden mb-8">
            {/* Carrousel pour mobile */}
            <div className="flex transition-transform duration-300 ease-in-out"
                 style={{ transform: `translateX(-${currentSlide * (100 / slidesPerView)}%)` }}>
              {courses.map((course, index) => (
                <div
                  key={course.id}
                  className="flex-shrink-0 px-2"
                  style={{ width: `${100 / slidesPerView}%` }}
                >
                  <CourseCard
                    course={{ ...course, image: course.image_url || course.image }}
                    animationDelay={index + 1}
                    onClick={() => window.location.href = `/courses/${course.slug || course.id}`}
                  />
                </div>
              ))}
            </div>

            {/* Contrôles de navigation pour mobile */}
            <div className="flex justify-center items-center mt-6 space-x-4">
              <button 
                onClick={prevSlide}
                className="p-2 rounded-full text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                aria-label="Previous slide"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              
              <div className="flex space-x-2">
                {courses.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`w-2 h-2 rounded-full ${index === currentSlide 
                      ? 'bg-blue-600 dark:bg-blue-500' 
                      : 'bg-gray-300 dark:bg-gray-600'}`}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
              
              <button 
                onClick={nextSlide}
                className="p-2 rounded-full text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                aria-label="Next slide"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        ) : (
          // Grille normale pour desktop
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {courses.map((course, index) => (
              <CourseCard
                key={course.id}
                course={{ ...course, image: course.image_url || course.image }}
                animationDelay={index + 1}
                onClick={() => window.location.href = `/courses/${course.slug || course.id}`}
              />
            ))}
          </div>
        )}

        {/* Bouton View All */}
        <div className="flex justify-center mt-12 lg:mt-16">
          <a href="/courses">
            <button className="px-6 py-3 border-2 text-button border-red-4 text-red-4 hover:bg-red-4 hover:text-white
              rounded-full transition-colors duration-300 font-medium">
              View All Courses
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PopularCourses;